module.exports = __webpack_public_path__ + "03_glasses_red.d50297dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/03_glasses_red.png
// module id = +TkO
// module chunks = 0